import { render, staticRenderFns } from "./AddAllergy.vue?vue&type=template&id=8d5bb4d4&scoped=true"
import script from "./AddAllergy.vue?vue&type=script&lang=js"
export * from "./AddAllergy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5bb4d4",
  null
  
)

export default component.exports